import { Injectable } from '@angular/core';
import { OperationRequest } from '../models/operations/operation-request';
import { Strategy } from '../models/strategies/abstract-strategy';
import { DefaultStrat } from '../models/strategies/default-strat';
import { DocumentStrat } from '../models/strategies/document-strat';
import { ErrorStrat } from '../models/strategies/error-strat';
import { IntroductionStrat } from '../models/strategies/introduction-strat';
import { SignatureStatusStrat } from '../models/strategies/signature-status-strat';
import { ThanksStrat } from '../models/strategies/thanks-strat';
import { LoginStrat } from '../models/strategies/login-strategy';
import { CustomCheckboxStrat } from '../models/strategies/customCheckbox-strat';
import { OperationNOTEStrat } from '../models/strategies/operationNOTE-strat';
import { SamlStrat } from '../models/strategies/saml-strategy';
import { AutomaticDownloadStrat } from '../models/strategies/automatic-download-strategy';

@Injectable({
    providedIn: 'root',
})

export class AuthorizationStrategyService {
    public routeStrategies: Array<Strategy>;

    constructor() {
        this.loadRouteStrategies();
    }

    private loadRouteStrategies() {
        this.routeStrategies = [
            new SamlStrat(),
            new LoginStrat(),
            new DefaultStrat(),
            new IntroductionStrat(),
            new AutomaticDownloadStrat(),
            new CustomCheckboxStrat(),
            new OperationNOTEStrat(),
            new DocumentStrat(),
            new SignatureStatusStrat(),
            new ThanksStrat(),
            new ErrorStrat()
        ];
    }

    getPath(request: OperationRequest): string {
        for (const routeStrat of this.routeStrategies) {
            if (routeStrat.hasCondition(request)) {
                routeStrat.setStrategy(request);
                return routeStrat.pathToGo
            }
        }
        return '/error';
    }
}
